import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationWrapper } from 'utils/common-methods';
import detailedDataIcon from '../../assets/images/detailed-data-visualisation.svg';
import precisionMonitoringIcon from '../../assets/images/precision-monitoring-icon.svg';
import predictiveAgronomicIcon from '../../assets/images/predictive-agro-icon.svg';
import remoteSensingIcon from '../../assets/images/remote-sensing-icon.svg';
import './styles.less';

const UpperBanner: React.FC = () => {
    const { t } = translationWrapper(useTranslation(), false);
    return (
        <div className="upper-banner-container">
            <div className="upper-banner-container-background">
                <div className="upper-banner-container-background-inner">
                    <img className="upper-banner-container-background-inner__protector-logo" alt=""/>
                    <span>{t('Upgrade your Agronomy')}</span>
                </div>
                <div className="upper-banner-container-background-inner">
                    <img className="upper-banner-container-background-inner__grower" alt=""/>
                </div>
            </div>
            <div className="upper-banner-container-background-lower">
                <span>
                   {t('Precision monitoring and predictive agronomic insights, powered by decades of Syngenta R&D, help you make effective and timely decisions throughout the season. With access to detailed data visualisation, alerts and task planning from your mobile, Protector gives you access to the information you need, when you need it!')}
                </span>
            </div>
        </div>
    );
  };

  const WhatProtectorCanDo: React.FC = () => {
  const { t } = translationWrapper(useTranslation(), false);
    return (
    <div className="protector-do-container">
        <iframe className="protector-do-container__iframe" src="https://www.youtube.com/embed/mX-KW6kVcgU" />
        <div className="protector-do-container__left">
            <div className="protector-do-text-container">
                <div className="protector-do-text-container__text">
                    <span>{t('What can Protector')}</span>
                    <div className="protector-do-text-container__background">
                        <span>
                            {t('do for you?')}
                        </span>
                    </div>
                </div>
                <span style={{ fontSize: '20px' }}>
                    {t('From field monitoring to analysis and decision making, Protector offers a complete solution for effective in-season farm management.')}
                </span>
            </div>
            <div className="protector-icons-container">
                <div className="protector-icons-container-inner">
                    <div className="protector-icons-container-inner-box">
                        <img alt="" src={precisionMonitoringIcon} />
                        <span>{t('Precision Monitoring')}</span>
                    </div>
                    <div className="protector-icons-container-inner-box">
                        <img alt="" src={predictiveAgronomicIcon} />
                        <span>{t('Predictive Agronomic Insights')}</span>
                    </div>

                </div>
                <div className="protector-icons-container-inner">
                    <div className="protector-icons-container-inner-box">
                        <img alt="" src={remoteSensingIcon} />
                        <span>{t('Remote Sensing')}</span>
                    </div>
                    <div className="protector-icons-container-inner-box">
                        <img alt="" src={detailedDataIcon} />
                        <span>{t('Detailed data visualisation')}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
  };

const ProtectorWhatIsIt: React.FC = () => {
  return (
      <div className="protector-explanation-container">
          <UpperBanner />
          <WhatProtectorCanDo />
      </div>
  );
};

export default ProtectorWhatIsIt;
